// Compact zh/en language switch. Persists via i18next's localStorage detector.
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { SUPPORTED_LANGS, type Lang } from "../i18n/index.js";
import { cn } from "@/lib/utils";

export function LanguageToggle({ className }: { className?: string }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? "zh") as Lang;

  return (
    <div
      className={cn(
        "inline-flex items-center gap-0.5 rounded-md border border-white/10 bg-black/30 p-0.5",
        className,
      )}
      role="group"
      aria-label="Language"
    >
      <Languages className="ml-1 mr-0.5 h-3.5 w-3.5 text-muted-foreground" aria-hidden />
      {SUPPORTED_LANGS.map((lng) => (
        <button
          key={lng}
          onClick={() => i18n.changeLanguage(lng)}
          aria-pressed={current === lng}
          className={cn(
            "rounded px-1.5 py-0.5 text-xs font-medium uppercase outline-none transition-colors focus-visible:ring-2 focus-visible:ring-ring",
            current === lng
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {lng}
        </button>
      ))}
    </div>
  );
}
